import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface Handyman {
  id: number;
  name: string;
  phoneNumber: string;
  serviceType: string;
}

interface HandymanState {
  handymen: Handyman[];
  loading: boolean;
  error: string | null;
}

const initialState: HandymanState = {
  handymen: [],
  loading: false,
  error: null,
};

const handymanSlice = createSlice({
  name: "handyman",
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
    setHandymen(state, action: PayloadAction<Handyman[]>) {
      state.handymen = action.payload;
      state.loading = false;
      state.error = null;
    },
    clearHandymen(state) {
      state.handymen = [];
    },
  },
});

export const handymanActons = handymanSlice.actions;

export default handymanSlice;
